
<template>
  <v-card variant="outlined" class="pa-2 mr-2 mb-2">
    <div class="d-flex align-center">
      <div>
        <strong>{{hour.time}}</strong> > <strong>{{endTime}}</strong>
        <p v-if="hour.name" class="font-weight-medium text-grey-darken-2">{{hour.name}}</p>
        <p v-if="hour.max_seats > 0"  class="text-error">{{hour.max_seats}} posti</p>
        <p v-if="hour.restricted" class="text-error">posti non prenotabili</p>
      </div>
      <div class="d-flex flex-column ml-3">
        <v-btn variant="text" icon="mdi-close" density="compact" color="error" @click="$emit('remove', hour)"></v-btn>
        <v-btn variant="text" icon="mdi-cog" density="compact"  color="primary" @click="$emit('edit', hour)"></v-btn>
      </div>

    </div>
  </v-card>
</template>

<script lang="ts">
import {computed, defineComponent, type PropType} from 'vue'
import type {CalendarHour} from "@/models.ts";
import {DateTime} from "luxon";

export default defineComponent({
  name: "CalendarHourCell",
  props : {
    hour : {
      type : Object as PropType<CalendarHour>,
      required : true
    }
  },
  emits : ['remove','edit'],
  setup(props, ctx) {
    return {
      endTime : computed(()=> {
        return DateTime.fromFormat(props.hour.time, 'HH:mm').plus({'minutes':props.hour.duration}).toFormat('HH:mm')
      }),
    }
  }
})
</script>



<style scoped>

</style>